/**
 * iPhone and iPad Safari zoom the page when a form field is focused whose text is under 16px, and leave
 * it zoomed, so the app then pans sideways and full-height panels (the menu) run off the screen.
 * Tyler's screen recording showed exactly that: everything at 1.14x, which is 16/14.
 *
 * `maximum-scale=1` stops that automatic zoom, and clamps a page that is already zoomed back to 100%.
 * Since iOS 10 Safari ignores it for pinch zoom, so people can still zoom by hand. It is added on iOS
 * only: Android Chrome does not auto-zoom, and there it would block pinch zoom.
 */
export function isAppleTouchDevice(
  nav: Pick<Navigator, "userAgent" | "platform" | "maxTouchPoints">,
) {
  return (
    /iPhone|iPad|iPod/.test(nav.userAgent) ||
    // iPadOS reports itself as a Mac; a Mac has no touch points.
    (nav.platform === "MacIntel" && nav.maxTouchPoints > 1)
  );
}

export function stopFocusZoom(doc: Document = document, nav: Navigator = navigator): boolean {
  if (!isAppleTouchDevice(nav)) return false;
  const meta = doc.querySelector('meta[name="viewport"]');
  const content = meta?.getAttribute("content") ?? "";
  if (!meta || /maximum-scale/.test(content)) return false;
  meta.setAttribute("content", `${content}, maximum-scale=1`);
  return true;
}
